import { render, staticRenderFns } from "./plan-price.vue?vue&type=template&id=788dcf76"
import script from "./plan-price.vue?vue&type=script&lang=js"
export * from "./plan-price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports